import { useTheme } from '../context/ThemeContext'

type Props = {
	className?: string
}

export default function ThemeToggle({ className = '' }: Props) {
	const { theme, toggleTheme } = useTheme()

	return (
			<div className={`theme-toggle ${className}`} onClick={toggleTheme} role="button" tabIndex={0}>
				<div className={`theme-toggle__btn ${theme === 'dark' ? 'active' : ''}`}>
					<img src={theme === 'dark' ? '/icons/moon_dark.svg' : '/icons/moon_light.svg'} alt="" />
				</div>
				<div className={`theme-toggle__btn ${theme === 'light' ? 'active' : ''}`}>
					<img src={theme === 'dark' ? '/icons/sun_dark.svg' : '/icons/sun_light.svg'} alt="" />
				</div>
			</div>
	)
}